// extracted by mini-css-extract-plugin
module.exports = {"authorBg":"author-module--author-bg--3izjh","author":"author-module--author--981WO"};